import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {
    IJourneyState, PropertyHelper, EOperatorType, IComponent, IBranch, IQueryBuilderConfigRule, IOutput,
    IConditionConfig
} from '../../helpers';
import { NO_VALUE_OPERATORS, VISIBILITY_EXPRESSION_PROPERTY_NAME } from '../../constants';
import { Button } from 'office-ui-fabric-react';
import store from '../../store/store';

interface IProps {
    journeySchema: IJourneyState;
    outputDictionary: { [id: string]: string };
    back: () => any;
}
export class Print extends React.Component<IProps, any> {

    counter = 0;

    visualiseJourney = (journey) => {
        let start = journey.StartId;
        this.counter = 0;
        try {
            return this.getChildrenFrom(start, journey);
        }
        catch (ex) {
            return <div>This journey contains errors, and cannot be displayed</div>
        }
    }

    getChildrenFrom = (journeyId, journey) => {
        let component: IComponent = journey.Components[journeyId];
        let html = [];
        while (component) {
            var children = [];
            let length = 1;
            this.counter++;

            html.push(this.renderComponent(component));

            if (component.ComponentType.Name == "Decision" && component.Decision.Branches.length > 0) {
                children = component.Decision.Branches.map((branch: IBranch) => {
                    if (branch.NextComponent) {
                        return <div className="children"><div className="conditions-inner"> <span>Condition: {branch.Name}</span> {branch.NextComponent && this.getChildrenFrom(branch.NextComponent.ComponentId, journey)}</div></div>;
                    }
                    else {
                        return null;
                    }
                });
            }

            if (component.NextComponent && component.NextComponent.ComponentId) {
                component = journey.Components[component.NextComponent.ComponentId];
            }
            else {
                component = null;
            }

            {
                children && html.push(<div className="conditions-wrapper">
                    <div className="conditions">{children}</div>
                </div>)
            }

        }

        return html;
    }

    enumerateJourney = (startId, journey, func) => {
        let component: IComponent = journey.Components[startId];

        while (component) {
            let children = "";
            let length = 1;

            func(component);

            if (component.ComponentType.Name == "Decision") {
                children += component.Decision.Branches.forEach((condition: IBranch) => {
                    condition.NextComponent && this.enumerateJourney(condition.NextComponent.ComponentId, journey, func)
                });
            }

            if (component.NextComponent && component.NextComponent.ComponentId) {
                component = journey.Components[component.NextComponent.ComponentId];
            }
            else {
                component = null;
            }

        }

    }

    renderComponent = (component) => {
        let type = component.ComponentType.Name
        switch (type) {
            case "Step":
                return <div className={component.ComponentType.Name}>{this.counter} - {component.Step.Properties.filter(x => x.Name == "Title")[0].Value}</div>;
            case "Action":
                return <div className={component.ComponentType.Name}>{this.counter} - {component.Action.Properties.filter(x => x.Name == "Action Name")[0].Value}</div>;
            case "Decision":
                return <div className={component.ComponentType.Name}>{this.counter} - {component.Decision.Properties.filter(x => x.Name == "Title")[0].Value}</div>;
            default:
                return <div className={component.ComponentType.Name}>{this.counter} - {component.ComponentType.Name}</div>;
        }

    }

    getAllOutputs = () => {
        let { journeySchema } = this.props;
        let components = [];
        let localOutputs = {};

        this.enumerateJourney(journeySchema.StartId, journeySchema, (component) => {
            components.push(component);
        });

        let outputArray2d = components.map((c) => {
            var type;
            switch (c.ComponentType.Name) {
                case "Step":
                    type = "Step";
                    return c[type].OutputValues ? c[type].OutputValues : [];
                case "Section":
                    type = "ControlBlock";
                    let outputs = [];
                    c[type].Controls.forEach((ctrl) => ctrl.OutputValues && ctrl.OutputValues.forEach((o) => { outputs.push(o) }));
                    return outputs;
                case "Block":
                    type = "ControlBlock";
                    let output = [];
                    c[type].Controls.forEach((ctrl) => ctrl.OutputValues && ctrl.OutputValues.forEach((o) => { output.push(o) }));
                    return output;

                case "Action":
                    type = "Action";
                    return c[type].OutputValues ? c[type].OutputValues : [];
                case "Decision":
                    type = "Decision";
                    return c[type].OutputValues ? c[type].OutputValues : [];
                case "Summary":
                    type = "Summary";
                    return c[type].OutputValues ? c[type].OutputValues : []
                case "Submission":
                    type = "Submission";
                    return c[type].OutputValues ? c[type].OutputValues : [];
                default:
                    return [];
            }
        });

        journeySchema.Outputs.forEach((o) => {
            localOutputs[o.Id] = o;
        });

        outputArray2d.forEach((c) => {
            c.forEach((o) => {
                localOutputs[o.Id] = o;
            });
        });

        return localOutputs;
    }

    getQueryDisplay = (config: IQueryBuilderConfigRule): JSX.Element => {

        if (!config.condition || !config.rules || !config.rules.length) {
            return null;
        }

        // default config detected, return null
        if (config.rules[0].operator === 'Equals' && config.rules[0].value == null) {
            return null;
        }

        return this.getConditionDisplay(config.condition, config.rules);

    }

    getConditionDisplay = (condition: any, rules: any): JSX.Element => {

        let elem: JSX.Element = <ul className='query-display'>
            <li className='condition-item'>{condition}</li>
            <li className='rules-item'>
                <ul>
                    {rules.map(this.getRuleDisplay)}
                </ul>
            </li>
        </ul>

        return elem;

    }

    getRuleDisplay = (rule: any, index: number): JSX.Element => {

        let { outputDictionary } = this.props;

        if (rule.condition) {
            return this.getConditionDisplay(rule.condition, rule.rules);
        }
        else {
            let fieldName = rule.field && rule.field.length && outputDictionary && outputDictionary[rule.field] ?
                '##' + outputDictionary[rule.field] + '##' : '-';
            return <li>{' - "' + fieldName + '" ' + rule.operator +
                (NO_VALUE_OPERATORS.indexOf(rule.operator) < 0 ? ' "' + this.replaceTokens(rule.value) + '"' : '')}</li>;
        }

    }

    replaceTokens = (value: string): string => {

        let { outputDictionary } = this.props;

        let tokens: string[] = value.split('##').filter(v => v.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i));

        tokens.forEach(t => {
            value = value.replace('##' + t + '##', '##' + outputDictionary[t] + '##');
        })

        return value;
    }

    getText = (text) => {
        var x, e;

        if (text === null) {
            return <i>(no value)</i>;
        }

        if (typeof text === 'boolean') {
            return text.toString();
        }

        // if rich text, extract the "plain text" version of the rich text    
        try {
            x = typeof JSON.parse(text).text !== "undefined" ? JSON.parse(text).text : text;
        }
        catch (ex) {
            e = ex;
            x = text;
        }

        // if the text contains GUIDS, do a lookup to the actual guid value
        try {
            if (x && x.length) {
                x = this.replaceTokens(x);
            }
        }
        catch (ex) {

        }

        return x;
    }

    getValueOptions = (options) => {
        return <ul>
            {options.map((option) => { return <li>{option.text} ({option.key})</li> })}
        </ul>
    }

    getOutputValuesTable = (outputValues) => {
        if (!outputValues || outputValues.length == 0) { return null }
        return <table className="summary-table">
            <thead>
                <tr>
                    <td>Name</td>
                    <td>Default Value</td>
                    <td>Global Output</td>
                    <td>Logical Name</td>
                    <td>Local Output</td>
                </tr>
            </thead>
            <tbody>
                {outputValues.map((prop, index) => {
                    return <tr key={index}>
                        <td>{this.getText(prop.Name)}</td>
                        <td>{this.getText(prop.PrepopulatedValue)}</td>
                        <td>{this.getText(prop.GlobalOutputId)}</td>
                        <td>{this.getText(prop.LogicalName)}</td>
                        <td>{this.getText(prop.StaticName)}</td>
                    </tr>
                })}
            </tbody>
        </table>
    }

    renderOutputValues = (outputValues) => {
        if (!outputValues || (outputValues && outputValues.length == 0)) { return false }

        return <table className="summary-table">
            <thead>
                <tr>
                    <td>Name</td>
                    <td>Default Value</td>
                    <td>Global Output</td>
                    <td>Logical Name</td>
                    <td>Local Output</td>
                </tr>
            </thead>
            {outputValues.map((prop, index) => {
                return <tr key={index}><td>{this.getText(prop.Name)}</td><td>{this.getText(prop.PrepopulatedValue)}</td><td>{this.getText(prop.GlobalOutputId)}</td><td>{this.getText(prop.LogicalName)}</td><td>{this.getText(prop.StaticName)}</td></tr>
            })}
        </table>
    }

    renderActionTable = (component) => {
        let outputValues = this.renderOutputValues(component.Action.OutputValues);
        let outputValuesMessage = outputValues ? <div> <h2>Output Values</h2> {outputValues}  </div> : null;

        return <div>
            <h1>{this.counter} - {component.ComponentType.Name} {component.Action.ActionType ? `(${component.Action.ActionType.NameType})` : ""}</h1>
            <div className="component-details">
                <h2>Properties</h2>
                <table className="summary-table">
                    <thead><tr><td>Property</td><td>Value</td></tr></thead>
                    <tbody>
                        {component.Action.Properties.map((prop, index) => {
                            return <tr key={index}><td>{prop.Name.trim()}</td><td>{this.getText(prop.Value && prop.Value.toString().trim())}</td></tr>
                        })}
                    </tbody>
                </table>
                {outputValuesMessage}
            </div></div>
    }

    getPropertyValue = (prop) => {
        if (prop.Name == "Value Options") {
            return this.getValueOptions(prop.ValueOptions);
        }
        else if (prop.Name === VISIBILITY_EXPRESSION_PROPERTY_NAME) {
            if (prop.Value && prop.Value.length) {
                let conditionConfig: IConditionConfig = JSON.parse(prop.Value);
                if (conditionConfig.AdvancedMode) {
                    return this.getText(conditionConfig.AdvancedConfig);
                }
                else {
                    return this.getQueryDisplay(conditionConfig.Config);
                }

            }
        }

        return this.getText(prop.Value);
    }

    renderBlockTable = (component) => {
        return <div> <h1>{this.counter} - {component.ComponentType.Name}</h1>
            <div className="component-details">
                <h2>Controls</h2>
                {component.ControlBlock.Controls.map((control, index) => {
                    let outputValues = this.renderOutputValues(control.OutputValues);
                    let outputValuesMessage = outputValues ? <div> <h4>Output Values</h4> {outputValues} </div> : null;

                    return <div key={index}><h3>{control.ControlType.NameType} - ({control.Properties && control.Properties.filter(x => x.Name == "Label")[0].Value})</h3>
                        {outputValuesMessage}
                        <h4>Properties</h4>
                        <table className="summary-table">
                            <tbody>
                                {control.Properties && control.Properties.map((prop, index) => {
                                    return <tr key={index}>
                                        <th width="200px">{prop.Name}</th>
                                        <td>{this.getPropertyValue(prop)}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>

                })}
            </div> </div>

    }

    renderDecisionTable = (component: IComponent) => {
        return <div>
            <h1>{this.counter} - {component.ComponentType.Name}</h1>
            <div className="component-details">
                <h2>Branches</h2>
                <table className="summary-table">
                    <tbody>
                        <tr>
                            <th>Name</th>
                            <th>Condition</th>
                        </tr>
                        {component.Decision.Branches.map((branch: IBranch, index) => {
                            return <tr>
                                <td width="200px">{branch.Name}</td>
                                <td>
                                    {branch.ConditionConfig.AdvancedMode ?
                                        this.getText(branch.ConditionConfig.AdvancedConfig) :
                                        this.getQueryDisplay(branch.ConditionConfig.Config)}
                                </td>
                            </tr>;
                        })}
                    </tbody>
                </table>

            </div>
        </div>
    }
    renderStepTable = (component) => {
        return <div><h1>{this.counter} - {component.ComponentType.Name} ({component.Step.Properties.filter(x => x.Name == "Title")[0].Value})</h1> <span>(no configuration details)</span></div>
    }

    renderSharedJourneyTable = (component) => {
        return <div><h1>{this.counter} - {component.ComponentType.Name}</h1>
            <div className="component-details">
                <h2>Input Values</h2>
                <table className="summary-table">
                    <thead><tr><td>Input Name</td><td>Input Value</td></tr></thead>
                    <tbody>
                        {component.SharedJourney.OutputValues.filter(o => o.CanBeSetByQueryString).map((prop, index) => {
                            return <tr key={index}><td>{prop.OutputLabelFromSharedJourney || prop.Name}</td><td>{this.getText(prop.InputValue)}</td></tr>
                        })
                        }
                    </tbody>
                </table>
                <h2>Output Values</h2>
                <table className="summary-table">
                    <thead><tr><td>Shared Output Name</td><td>Local Output Name</td></tr></thead>
                    <tbody>
                        {component.SharedJourney.OutputValues.map((prop, index) => {
                            return <tr key={index}><td>{prop.OutputLabelFromSharedJourney || prop.Name}</td><td>{this.getText(prop.LogicalName && prop.LogicalName.toString())}</td></tr>
                        })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    }
    renderSubmissionTable = (component) => {
        return <div><h1>{this.counter} - {component.ComponentType.Name}</h1>
            <div className="component-details">
                <h2>Properties</h2>
                <table className="summary-table">
                    <thead><tr><td>Property</td><td>Value</td></tr></thead>
                    <tbody>
                        {component.Submission.Properties.map((prop) => {
                            return <tr><td>{prop.Name.trim()}</td><td>{this.getText(prop.Value && prop.Value.toString().trim())}</td></tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    }

    renderSummaryTable = (component) => {
        return <div><h1>{this.counter} - {component.ComponentType.Name}</h1>
            <div className="component-details">
                <h2>Outputs</h2>
                <table className="summary-table">
                    <thead><tr><td>Output</td><td>Group</td></tr></thead>
                    <tbody>
                        {Object.keys(this.getAllOutputs()).map((k) => {
                            return this.getAllOutputs()[k];
                        }).filter(x => x.DisplayOnSummary).sort((x, y) => {
                            return x.Group == y.Group ? 0 : x.Group > y.Group ? 1 : -1
                        }).map((o) => {
                            return <tr><td title="{o.Id}">{o.Name}</td><td>{o.Group}</td></tr>
                        })}

                    </tbody>
                </table>
            </div>
        </div>

    }

    renderRedirectTable = (component) => {

        let options = store.getState().cacheState.redirectCandidateTypeOptions;
        let to = component.Redirect.Properties.filter(prop => prop.Name === "To")[0] ? component.Redirect.Properties.filter(prop => prop.Name === "To")[0].Value : null;
        let $to = to ? (
            <div className="component-details">
                <h2>To</h2>
                <table className="summary-table">
                    <thead><tr><td>Property</td><td>Value</td></tr></thead>
                    <tbody>
                        <tr><td>Type</td><td>{options.filter(o => o.key == to.Type)[0].text}</td></tr>
                        {to.Properties.map((prop) => {
                            return <tr><td>{prop.Name}</td><td>{this.getText(prop.Value)}</td></tr>
                        })}
                    </tbody>
                </table>
            </div>
        ) : null;
        return (<div><h1>{this.counter} - {component.ComponentType.Name}</h1>
            {$to}
            <div className="component-details">
                <h2>Properties</h2>
                <table className="summary-table">
                    <thead><tr><td>Property</td><td>Value</td></tr></thead>
                    <tbody>
                        {component.Redirect.Properties.filter(prop => prop.Name !== "To").map((prop) => {
                            return <tr><td>{prop.Name}</td><td>{this.getText(prop.Value !== null ? prop.Value : prop.Default)}</td></tr>
                        })}
                    </tbody>
                </table>
            </div>
        </div>);
    }

    renderDefaultTable = (component) => {
        return <div><h1>{this.counter} - {component.ComponentType.Name}</h1><span>(no configuration details available)</span></div>
    }
    renderTable = (component) => {
        let type = component.ComponentType.Name
        var returnComponent;
        try {
            switch (type) {
                case "Action":
                    returnComponent = this.renderActionTable(component);
                    break;
                case "Block":
                    returnComponent = this.renderBlockTable(component);
                    break;
                case "Section":
                    returnComponent = this.renderBlockTable(component);
                    break;
                case "Decision":
                    returnComponent = this.renderDecisionTable(component);
                    break;
                case "Step":
                    returnComponent = this.renderStepTable(component);
                    break;
                case "Shared journey":
                    returnComponent = this.renderSharedJourneyTable(component);
                    break;
                case "Submission":
                    returnComponent = this.renderSubmissionTable(component);
                    break;
                case "Summary":
                    returnComponent = this.renderSummaryTable(component);
                    break;
                case "Redirect":
                    returnComponent = this.renderRedirectTable(component);
                    break;
                default:
                    returnComponent = this.renderDefaultTable(component);
                    break;
            }
        }
        catch (ex) {
            console.log(ex);
            returnComponent = <div><h1>{this.counter} - {component.ComponentType.Name}</h1><span>(Configuration error. Please check configuration of this component)</span></div>
        }

        return returnComponent;

    }

    componentDidMount() {
        // var node = ReactDOM.findDOMNode(this);
        // try{
        //     domtoimage.toPng(node)
        //     .then((dataUrl) => {
        //         this.setState({ image: dataUrl });
        //     })
        //     .catch(function (error) {
        //         console.error('oops, something went wrong!', error);
        //     });
        // }
        // catch (ex) {
        //     // sets image to "true", allowing the rest of the information to display
        //     this.setState({ image: true });
        // }

    }

    constructor() {
        super();
    }

    render() {
        let journeyTitle: string = PropertyHelper.getPropertyValue(this.props.journeySchema.Properties, 'Title');

        let html = [];
        this.counter = 0;
        this.enumerateJourney(this.props.journeySchema.StartId, this.props.journeySchema, (component) => {
            this.counter++;
            html.push(<div key={this.counter} className="journey-details__wrapper">{this.renderTable(component)}</div>);
        });

        let style = `body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            background-color: #fff !important;
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
        }

        body,
        .container {
            display: table;
            min-width: 300px;
            margin: auto;
        }

        .conditions-wrapper {
            display: table;
            border-collapse: separate;
            border-spacing: 5px;
            table-layout: fixed;
            min-width: 100%;
        }

        .conditions {
            display: flex;
            justify-content: center;
            overflow: hidden;        }

        .conditions > .children {
            display: flex;
            border: 1px solid #AAA;
            margin: 5px;
            flex: 1;
            align-self: center;        }

        .conditions-inner {
            padding: 5px;
        }

        .Step,
        .Action,
        .Section,
        .Block,
        .Section
        .Decision,
        .Shared,
        .Submission,
        .Summary,
        .Redirect {
            width: 200px;
            padding: 10px;
            margin: 5px auto;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .Step {
            background-color: #86C2D5 !important;
            color: #FFF !important;
        }

        .Action {
            background-color: #e81123 !important;
            color: #FFF !important;
        }

        .Block {
            background-color: #5c2d91 !important;
            color: #FFF !important;
        }

        .Section {
            background-color: #5c2d91 !important;
            color: #FFF !important;
        }

        .Decision {
            background-color: #CEDD40 !important;
            color: #FFF !important;
        }

        .Shared {
            background-color: #333 !important;
            color: #FFF !important;
        }

        .Submission {
            background-color: green !important;
            color: #FFF !important;
        }

        .Summary {
            background-color: green !important;
            color: #FFF !important;
        }
        
        .Redirect{
            background-color: #ff8c00 !important;
            color: #FFF !important;
        }

        a[download] {
            display: block;
            margin: auto;
            box-shadow: 0px 0px 3px 1px #AAA;
            padding: 5px;
            margin: 10px;
            width: 720px;
            transition: 0.3s;
        }

        a:hover {
            box-shadow: 0px 0px 5px 2px #AAA;
        }

        .print-image__wrapper {
            overflow: hidden;
        }
        .print-image__wrapper img {
            display: block;
            margin: auto;
            max-width: 100%;
        }

        .summary-table {
            table-layout: fixed;
            width: 720px;
            text-overflow: ellipsis;
            word-break: break-all;
        }

        .summary-table th,
        .summary-table thead td {
            background-color: #0668b3 !important;
            color: #FFF !important;
        }

        .summary-table,
        .summary-table table,
        .summary-table td,
        .summary-table th {
            border: 1px solid #333;
            margin: 20px;
            border-collapse: collapse;
            padding: 8px;
        }

        .summary-table th,
        .summary-table td {
            vertical-align: top;
        }

        h1,
        h2,
        h3,
        h4 {
            white-space: nowrap;
            overflow: hidden;
            width: 720px;
            text-overflow: ellipsis;
        }

        h1 {
            border-bottom: 2px solid #0668b3;
            margin-top: 16px;
            padding-bottom: 14px;
        }

        h2 {
            padding-left: 6px;
        }

        h3 {
            padding-left: 12px;
        }

        h4 {
            padding-left: 18px;
        }

        body, body + div, body + div + div, body + div + div + div {
            display: table;
        }`

        return <div width={"100%"}>

            <style dangerouslySetInnerHTML={{ __html: style }} ></style>
            {<h1>{journeyTitle}</h1>}
            {<Button onClick={this.props.back} >Back</Button>}
            {this.visualiseJourney(this.props.journeySchema)}
            {html}
        </div>
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/print/index.tsx